import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxState } from "..";
import { getXeroContacts, createXeroContact } from "../../docuclipper/api";

export interface XeroContact {
  name: string;
  value: string;
}

const initialState: {
  xeroContacts: XeroContact[];
  loading: boolean;
  creating: boolean;
  error: string | null;
} = {
  xeroContacts: [],
  loading: false,
  creating: false,
  error: null,
};

const slice = createSlice({
  name: "XeroContact",
  initialState,
  reducers: {
    load(state) {
      state.loading = true;
      state.error = null;
    },
    setData(state, action: PayloadAction<XeroContact[]>) {
      state.loading = false;
      state.xeroContacts = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.creating = false;
      state.error = action.payload;
    },
    addXeroContact(state, action: PayloadAction<XeroContact>) {
      state.xeroContacts.unshift(action.payload);
      state.creating = false;
    },
    setCreating(state, action: PayloadAction<boolean>) {
      state.creating = action.payload;
    },
  },
});

export const { load, setError, setData, addXeroContact, setCreating } = slice.actions;

export const fetchXeroContacts = (integrationId: number, search?: string) => async (dispatch, getState) => {
  const state: ReduxState = getState();
  if (state.XeroContact.loading) {
    return;
  }
  dispatch(load());
  try {
    const contacts = await getXeroContacts(integrationId, search);
    dispatch(
      setData(
        (contacts || []).map((c: any) => ({
          // Xero API returns lowercase field names
          name: c.name || c.Name,
          value: c.contactID || c.ContactID,
        }))
      )
    );
  } catch (err) {
    dispatch(setError((err as any).message || "Error getting Xero contacts"));
  }
};

export const createAndAddXeroContact = (integrationId: number, contactName: string) => async (dispatch, getState) => {
  dispatch(setCreating(true));
  try {
    const contact = await createXeroContact(integrationId, contactName);
    const newContact = {
      // Handle both lowercase and uppercase field names
      name: contact.name || contact.Name,
      value: contact.contactID || contact.ContactID,
    };
    dispatch(addXeroContact(newContact));
    return newContact;
  } catch (err) {
    dispatch(setError((err as any).message || "Error creating Xero contact"));
    throw err;
  }
};

export default slice.reducer;

